import { create } from 'zustand';

interface SchedulingAgentState {
  isOpen: boolean;
  initialMessage?: string;
  open: (prompt?: string) => void;
  close: () => void;
}

export const useSchedulingAgent = create<SchedulingAgentState>((set) => ({
  isOpen: false,
  initialMessage: undefined,
  open: (prompt) => set({ isOpen: true, initialMessage: prompt }),
  close: () => set({ isOpen: false, initialMessage: undefined }),
}));
